import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class OrderGroupDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          dropdownType="order_group"
          type="order_group"
          fields={['id', 'name']}
          formId={form}
          name={name}
          onPostChange={onPostChange}
          preload={preload}
          searchFn={searchFn}
          textField="name"
          valueField="id"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(OrderGroupDropdown);
